import { SelectOption } from '@fleet-beat/core';

export enum AlertSoundType {
  AlarmClock = 'alarm',
  Danger = 'danger',
  Notification = 'notification',
  Rooster = 'rooster',
}

export enum AlertStatus {
  Read = 'read',
  Unread = 'unread',
}

export const AlertSoundTypes: SelectOption[] = [
  { value: AlertSoundType.Notification, label: 'Notification' },
  { value: AlertSoundType.AlarmClock, label: 'Alarm Clock' },
  { value: AlertSoundType.Danger, label: 'Danger' },
  { value: AlertSoundType.Rooster, label: 'Rooster' },
];
